module.exports = __webpack_public_path__ + "img/jiang.2848fd91.svg";